import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PageLayout from './PageLayout';
import './MainPage.css';

const MainPage = () => {
  const { t } = useTranslation();
  const isLoggedIn = useSelector(state => state.isLoggedIn);
  const userSubType = useSelector(state => state.subType);
  const navigate = useNavigate();

  const scrollToCards = () => {
    const cardsSection = document.querySelector('.interactive-panels');
    cardsSection?.scrollIntoView({ behavior: 'smooth' });
  };

  const panels = [
    { 
      id: 'bitcoin', 
      title: t('btcRelatedStocks'),
      link: '/products',
      sections: [
        {
          title: t('seizeOpportunities'),
          description: t('seizeOpportunitiesDescription'),
          tag: 'free'
        },
        {
          title: t('stayAhead'),
          description: t('stayAheadDescription'),
          tag: 'free'
        },
        {
          title: t('premiumBenefits'),
          description: t('premiumBenefitsDescription'),
          tag: 'pro'
        }
      ],
      icon: '₿'
    },
    { 
      id: 'etfs', 
      title: t('btcRelatedEtfs'),
      comingSoon: false,
      link: '/products/btc/etf-screener',
      sections: [
        {
          title: t('seizeEtfOpportunities'),
          description: t('seizeEtfOpportunitiesDescription'),
          points: [t('seizeEtfOpportunitiesPoint')],
          tag: 'free'
        },
        {
          title: t('stayAheadEtf'),
          description: t('stayAheadEtfDescription'),
          points: [t('stayAheadEtfPoint')],
          tag: 'free'
        },
        {
          title: t('etfPremiumBenefits'),
          description: t('etfPremiumBenefitsDescription'),
          points: [
            t('etfPremiumBenefitsPoint1'),
            t('etfPremiumBenefitsPoint2'),
            t('etfPremiumBenefitsPoint3')
          ],
          tag: 'pro'
        }
      ],
      icon: '📊'
    },
    { 
      id: 'longterm', 
      title: t('longTermStocks'),
      comingSoon: false,
      link: '/long-term',
      sections: [
        {
          title: t('buildWealthDescription'),
          description: t('buildWealthFullDescription'),
          tag: 'free'
        },
        {
          title: t('analyzeStocks'),
          description: t('analyzeStocksDescription'),
          tag: 'free'
        },
        {
          title: t('longTermPremiumBenefits'),
          description: t('longTermPremiumBenefitsDescription'),
          tag: 'pro'
        }
      ],
      icon: '📈'
    }
  ];

  return (
    <PageLayout>
      <div className="main-landing-content">
        <div className="hero-section">
          <div className="ribbon-container">
            <div className="ribbon"></div>
            <div className="ribbon"></div>
            <div className="ribbon"></div>
            <div className="ribbon"></div>
            <div className="ribbon"></div>
            <div className="ribbon"></div>
            <div className="ribbon"></div>
            <div className="ribbon"></div>
            <div className="ribbon"></div>
            <div className="ribbon"></div>
          </div>
          
          <div className="hero-content">
            <h1 className="animated-title">
              <span className="title-text">Pick Your Stocks</span>
            </h1>
            <p className="slogan">{t('slogan')}</p>
            <Link 
              to="/picks/bitcoinstocks" 
              className="cta-button"
              onClick={(e) => {
                e.preventDefault();
                scrollToCards();
              }}
            >
              {t('getStarted')}
            </Link>
          </div>
        </div>

        <div className="content-wrapper">
          <div className="interactive-panels">
            {panels.map((panel) => (
              <div 
                key={panel.id} 
                className={`panel ${panel.link ? 'clickable' : ''}`}
                onClick={() => {
                  if (panel.link) {
                    if (panel.id === 'etfs') {
                      navigate(panel.link);
                      localStorage.setItem('activeCategory', 'etf-overview');
                      localStorage.setItem('expandedItems', JSON.stringify(['btc-related-etfs']));
                    } else {
                      navigate(panel.link);
                    }
                  }
                }}
              >
                <div className="panel-icon">{panel.icon}</div>
                <div className="panel-header">
                  <h2 className="panel-title">{panel.title}</h2>
                  {panel.comingSoon && <span className="coming-soon-tag">{t('comingSoon')}</span>}
                </div>
                <div className="panel-description">
                  {panel.sections.map((section, index) => (
                    <div key={index} className={`section ${section.tag}-section`}>
                      <h3 className={`section-title ${section.tag}-title`}>{section.title}</h3>
                      <p className={`section-description ${section.tag}-description`}>
                        {section.description.split('\n').map((line, i) => (
                          <React.Fragment key={i}>
                            {line}
                            {i < section.description.split('\n').length - 1 && <br />}
                          </React.Fragment>
                        ))}
                      </p>
                      <span className={`tag ${section.tag}-tag`}>
                        {section.tag.toUpperCase()}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default MainPage;
